var _defs, _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    zoomAndPan: "magnify",
    viewBox: "0 0 810 809.999993",
    height: 1080,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    id: "73692b8533"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0",
    colorInterpolationFilters: "sRGB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "b0f8d8aae0"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#73692b8533)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -81,
    width: 972,
    fill: "#000000",
    y: -80.999999,
    height: 971.999992,
    fillOpacity: 0.08
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "75cb978e00"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1 0.078125 L 55.601562 0.078125 L 55.601562 69.679688 L 1 69.679688 Z M 1 0.078125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e6a95d5121"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 56,
    y: 0,
    height: 70
  })), /*#__PURE__*/React.createElement("mask", {
    id: "0873b530da"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#73692b8533)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -81,
    width: 972,
    fill: "#000000",
    y: -80.999999,
    height: 971.999992,
    fillOpacity: 0.16
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "ca6cd9a9ac"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.0390625 1 L 69 1 L 69 55.800781 L 0.0390625 55.800781 Z M 0.0390625 1 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f05d4d05d2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 70,
    y: 0,
    height: 56
  })), /*#__PURE__*/React.createElement("mask", {
    id: "dd79f8ba87"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#73692b8533)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -81,
    width: 972,
    fill: "#000000",
    y: -80.999999,
    height: 971.999992,
    fillOpacity: 0.24
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "d5b184c56c"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 75,
    y: 0,
    height: 36
  })), /*#__PURE__*/React.createElement("mask", {
    id: "babca88339"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#73692b8533)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -81,
    width: 972,
    fill: "#000000",
    y: -80.999999,
    height: 971.999992,
    fillOpacity: 0.32
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "0a753dc6e5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.320312 0.359375 L 69 0.359375 L 69 54.839844 L 0.320312 54.839844 Z M 0.320312 0.359375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ff0ab90f17"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 70,
    y: 0,
    height: 55
  })), /*#__PURE__*/React.createElement("mask", {
    id: "ca65917f01"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#73692b8533)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -81,
    width: 972,
    fill: "#000000",
    y: -80.999999,
    height: 971.999992,
    fillOpacity: 0.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "b9aba8c284"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.199219 0.0390625 L 55 0.0390625 L 55 69.640625 L 0.199219 69.640625 Z M 0.199219 0.0390625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eea8b7820e"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 56,
    y: 0,
    height: 70
  })), /*#__PURE__*/React.createElement("mask", {
    id: "ea579939fe"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#73692b8533)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -81,
    width: 972,
    fill: "#000000",
    y: -80.999999,
    height: 971.999992,
    fillOpacity: 0.48
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "2e861a0101"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.398438 1 L 35 1 L 35 75 L 0.398438 75 Z M 0.398438 1 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "03c5a804b3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 36,
    y: 0,
    height: 75
  })), /*#__PURE__*/React.createElement("mask", {
    id: "88acdee609"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#73692b8533)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -81,
    width: 972,
    fill: "#000000",
    y: -80.999999,
    height: 971.999992,
    fillOpacity: 0.56
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "ee495f8dc9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.160156 1 L 54.640625 1 L 54.640625 70 L 0.160156 70 Z M 0.160156 1 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "47f7b15bde"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 55,
    y: 0,
    height: 71
  })), /*#__PURE__*/React.createElement("mask", {
    id: "b3c238b11f"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#73692b8533)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -81,
    width: 972,
    fill: "#000000",
    y: -80.999999,
    height: 971.999992,
    fillOpacity: 0.64
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "a1cf479bc5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.359375 0.199219 L 69.960938 0.199219 L 69.960938 54.679688 L 0.359375 54.679688 Z M 0.359375 0.199219 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "532abf4526"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 70,
    y: 0,
    height: 55
  })), /*#__PURE__*/React.createElement("mask", {
    id: "98f0368cc9"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#73692b8533)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -81,
    width: 972,
    fill: "#000000",
    y: -80.999999,
    height: 971.999992,
    fillOpacity: 0.72
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "2d7c27922d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0.398438 L 74 0.398438 L 74 35 L 0 35 Z M 0 0.398438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ec875fe562"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 75,
    y: 0,
    height: 36
  })), /*#__PURE__*/React.createElement("mask", {
    id: "33713751ac"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#73692b8533)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -81,
    width: 972,
    fill: "#000000",
    y: -80.999999,
    height: 971.999992,
    fillOpacity: 0.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "e22b5766d3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1 0.160156 L 70 0.160156 L 70 54.640625 L 1 54.640625 Z M 1 0.160156 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5d254d0256"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 71,
    y: 0,
    height: 55
  })), /*#__PURE__*/React.createElement("mask", {
    id: "f0828b6b6f"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#73692b8533)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -81,
    width: 972,
    fill: "#000000",
    y: -80.999999,
    height: 971.999992,
    fillOpacity: 0.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "aa426303d4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.320312 0.359375 L 54.800781 0.359375 L 54.800781 69.960938 L 0.320312 69.960938 Z M 0.320312 0.359375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "32483a6875"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 55,
    y: 0,
    height: 70
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#de8dff",
    d: "M 405.863281 316.941406 C 396.523438 316.941406 388.953125 309.371094 388.953125 300.03125 L 388.953125 259.945312 C 388.953125 250.605469 396.523438 243.035156 405.863281 243.035156 C 415.203125 243.035156 422.773438 250.605469 422.773438 259.945312 L 422.773438 300.03125 C 422.773438 309.363281 415.203125 316.941406 405.863281 316.941406 Z M 405.863281 316.941406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b0f8d8aae0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 440, 262)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e6a95d5121)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#75cb978e00)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#de8dff",
    d: "M 9.800781 67.199219 C 1.714844 62.523438 -1.050781 52.1875 3.621094 44.09375 L 23.671875 9.390625 C 28.34375 1.304688 38.683594 -1.460938 46.773438 3.210938 C 54.859375 7.882812 57.625 18.222656 52.953125 26.3125 L 32.902344 61.019531 C 28.230469 69.101562 17.890625 71.863281 9.800781 67.199219 Z M 9.800781 67.199219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#0873b530da)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 479, 315)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f05d4d05d2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ca6cd9a9ac)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#de8dff",
    d: "M 2.714844 46.789062 C -1.949219 38.699219 0.832031 28.359375 8.914062 23.695312 L 43.640625 3.671875 C 51.734375 -0.992188 62.070312 1.789062 66.738281 9.875 C 71.402344 17.964844 68.621094 28.304688 60.539062 32.96875 L 25.8125 52.992188 C 17.71875 57.65625 7.382812 54.882812 2.714844 46.789062 Z M 2.714844 46.789062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#dd79f8ba87)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 492, 388)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d5b184c56c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#de8dff",
    d: "M 1.046875 17.984375 C 1.054688 8.644531 8.628906 1.082031 17.96875 1.089844 L 58.054688 1.125 C 67.394531 1.132812 74.957031 8.710938 74.949219 18.050781 C 74.941406 27.386719 67.367188 34.953125 58.027344 34.945312 L 17.941406 34.910156 C 8.601562 34.902344 1.039062 27.324219 1.046875 17.984375 Z M 1.046875 17.984375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#babca88339)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 478, 441)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ff0ab90f17)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0a753dc6e5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#de8dff",
    d: "M 2.746094 8.914062 C 7.425781 0.832031 17.769531 -1.921875 25.847656 2.757812 L 60.53125 22.84375 C 68.617188 27.523438 71.371094 37.867188 66.6875 45.945312 C 62.007812 54.03125 51.664062 56.785156 43.585938 52.101562 L 8.902344 32.019531 C 0.824219 27.335938 -1.933594 17 2.746094 8.914062 Z M 2.746094 8.914062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ca65917f01)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 439, 479)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eea8b7820e)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b9aba8c284)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#de8dff",
    d: "M 9.117188 2.800781 C 17.214844 -1.859375 27.546875 0.933594 32.207031 9.03125 L 52.191406 43.769531 C 56.851562 51.867188 54.058594 62.199219 45.960938 66.859375 C 37.863281 71.519531 27.53125 68.726562 22.871094 60.628906 L 2.894531 25.890625 C -1.765625 17.792969 1.027344 7.453125 9.117188 2.800781 Z M 9.117188 2.800781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ea579939fe)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 386, 492)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#03c5a804b3)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2e861a0101)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#de8dff",
    d: "M 17.914062 1.082031 C 27.253906 1.097656 34.8125 8.6875 34.789062 18.019531 L 34.710938 58.105469 C 34.695312 67.445312 27.105469 75 17.773438 74.980469 C 8.433594 74.964844 0.878906 67.371094 0.898438 58.039062 L 0.976562 17.957031 C 0.992188 8.625 8.574219 1.066406 17.914062 1.082031 Z M 17.914062 1.082031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#88acdee609)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 314, 477)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#47f7b15bde)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ee495f8dc9)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#de8dff",
    d: "M 46 3.746094 C 54.078125 8.433594 56.824219 18.777344 52.136719 26.855469 L 32.023438 61.523438 C 27.335938 69.601562 16.988281 72.347656 8.910156 67.660156 C 0.835938 62.972656 -1.910156 52.625 2.777344 44.550781 L 22.890625 9.882812 C 27.570312 1.804688 37.921875 -0.941406 46 3.746094 Z M 46 3.746094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b3c238b11f)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 261, 439)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#532abf4526)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a1cf479bc5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#de8dff",
    d: "M 67.140625 9.089844 C 71.792969 17.1875 68.996094 27.523438 60.890625 32.171875 L 26.136719 52.121094 C 18.039062 56.769531 7.699219 53.972656 3.054688 45.867188 C -1.597656 37.769531 1.199219 27.433594 9.304688 22.789062 L 44.066406 2.832031 C 52.160156 -1.8125 62.496094 0.984375 67.140625 9.089844 Z M 67.140625 9.089844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#98f0368cc9)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 243, 386)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ec875fe562)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2d7c27922d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#de8dff",
    d: "M 73.898438 17.871094 C 73.867188 27.210938 66.277344 34.761719 56.9375 34.734375 L 16.851562 34.617188 C 7.519531 34.597656 -0.0273438 27.003906 0 17.664062 C 0.0273438 8.324219 7.621094 0.777344 16.960938 0.804688 L 57.042969 0.921875 C 66.375 0.941406 73.925781 8.53125 73.898438 17.871094 Z M 73.898438 17.871094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#33713751ac)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 262, 314)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5d254d0256)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e22b5766d3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#de8dff",
    d: "M 67.285156 45.964844 C 62.589844 54.035156 52.234375 56.773438 44.167969 52.078125 L 9.519531 31.929688 C 1.449219 27.234375 -1.289062 16.882812 3.402344 8.8125 C 8.097656 0.742188 18.453125 -1.996094 26.519531 2.699219 L 61.167969 22.847656 C 69.238281 27.542969 71.976562 37.894531 67.285156 45.964844 Z M 67.285156 45.964844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#f0828b6b6f)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 316, 261)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#32483a6875)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aa426303d4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#de8dff",
    d: "M 45.96875 67.140625 C 37.863281 71.785156 27.53125 68.976562 22.894531 60.871094 L 2.972656 26.085938 C -1.671875 17.980469 1.140625 7.648438 9.246094 3.011719 C 17.351562 -1.632812 27.683594 1.179688 32.320312 9.285156 L 52.242188 44.066406 C 56.878906 52.164062 54.074219 62.503906 45.96875 67.140625 Z M 45.96875 67.140625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoad);
export default __webpack_public_path__ + "static/media/load.e1f862a524f2fdcdc8d8eaa99dff9b53.svg";
export { ForwardRef as ReactComponent };